import React from "react";
import { useI18n } from "@/i18n";

function LegalPage({ pageKey, testId }) {
  const { tRaw, t } = useI18n();
  const data = tRaw(`pages.${pageKey}`) || {};
  const sections = data.sections || [];

  return (
    <main
      data-testid={testId}
      className="bg-[#FAF9F5] py-14 lg:py-20 min-h-[60vh]"
    >
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="font-serif text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight">
          {data.title}
        </h1>
        <p className="mt-2 text-sm text-slate-500 uppercase tracking-widest">
          {data.updated}
        </p>
        <p className="mt-6 text-slate-700 leading-relaxed">{data.intro}</p>
        <div className="mt-10 space-y-8">
          {sections.map((s, i) => (
            <section key={i} data-testid={`${testId}-section-${i}`}>
              <h2 className="font-serif text-xl sm:text-2xl font-semibold text-slate-900">
                {s.title}
              </h2>
              <p className="mt-2 text-slate-700 leading-relaxed">{s.body}</p>
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}

export function PrivacyPage() {
  return <LegalPage pageKey="privacy" testId="privacy-page" />;
}
export function CookiesPage() {
  return <LegalPage pageKey="cookies" testId="cookies-page" />;
}
export function TermsPage() {
  return <LegalPage pageKey="terms" testId="terms-page" />;
}
